import { Component, Fragment } from 'react';
import { postData, putData, getData } from "../../servicos/api";
import { isAdmin } from "../../servicos/auth";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form, FormGroup, Label, Input, Button, Card, CardHeader, CardBody, CardFooter, Row } from 'reactstrap';
import Navbar from '../../Components/Navbar';
import Sidebar from '../../Components/Sidebar';
import ModalResponse from '../../Components/ModalResponse';
import InputFile from '../../Components/InputFile';
import Combobox from '../../Components/Combobox';
import { Link } from "react-router-dom";
import Switch from 'react-switch';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

//REDUX
import { setLoaderShow, setResponseModal } from '../../reducers/index';
import { connect } from 'react-redux';

import { queryClient } from '../../utilidades/queryClient';

const numberMask = createNumberMask({
    prefix: 'R$ ',
    includeThousandsSeparator: true,
    thousandsSeparatorSymbol: '.',
    allowDecimal: true,
    decimalSymbol: ',',
    decimalLimit: 2,
    allowNegative: false,
    requireDecimal: true
});

const Formulario = (props) => {
    let estabelecimento;
    if (props.data && props.data.estabelecimento_id !== undefined && props.data.estabelecimento_id !== null && props.listaEstabelecimentos.length > 0) {
        estabelecimento = props.listaEstabelecimentos.filter(function (elem, i, object) {
            return elem.value === props.data.estabelecimento_id;
        });
        if(estabelecimento[0] !== undefined){
            estabelecimento = { value: estabelecimento[0].value, label: estabelecimento[0].label };
        }
    }

    let tipo_produto;
    if (props.data && props.data.tipo_produto_id !== undefined && props.data.tipo_produto_id !== null && props.listaTiposProduto.length > 0) {
        tipo_produto = props.listaTiposProduto.filter(function (elem, i, object) {
            return elem.value === props.data.tipo_produto_id;
        });
        if(tipo_produto[0] !== undefined){
            tipo_produto = { value: tipo_produto[0].value, label: tipo_produto[0].label };
        }
    }

    let arquivo_label = "";
    if (props.data && props.data.imagem !== undefined && props.data.imagem !== null && props.data.imagem !== "") {
        arquivo_label = "Arquivo selecionado";
    }

    let validarAdmin = Yup.object({
        estabelecimento_id: Yup.object()
            .required('O campo estabelecimento é obrigatório.'),
        tipo_produto_id: Yup.object()
            .required('O campo tipo do produto é obrigatório.'),
        nome: Yup.string()
            .min(5, 'O campo nome deverá ter no mínimo 5 caracteres.')
            .max(90, 'O campo nome deverá ter no máximo 90 caracteres.')
            .required('O campo nome é obrigatório.')
            .trim(),
        descricao: Yup.string()
            .nullable()
            .max(500, 'O descrição nome deverá ter no máximo 500 caracteres.')
            .trim(),
        arquivo: Yup.mixed()
            .nullable()
    });

    let validarEstabelecimento = Yup.object({
        tipo_produto_id: Yup.object()
            .required('O campo tipo do produto é obrigatório.'),
        nome: Yup.string()
            .min(2, 'O campo nome deverá ter no mínimo 2 caracteres.')
            .max(90, 'O campo nome deverá ter no máximo 90 caracteres.')
            .required('O campo nome é obrigatório.')
            .trim(),
        descricao: Yup.string()
            .nullable()
            .max(500, 'O descrição nome deverá ter no máximo 500 caracteres.')
            .trim(),
        arquivo: Yup.mixed()
            .nullable()
    });

    const formik = useFormik({

        initialValues: {
            estabelecimento_id:   estabelecimento,
            tipo_produto_id:      tipo_produto,
            nome:                 props.data !== undefined && props.data !== null ? props.data.nome : '',
            valor:                props.data !== undefined && props.data !== null ? props.data.valor :   '',
            descricao:            props.data !== undefined && props.data !== null ? props.data.descricao :   '',
            quantidade:           props.data !== undefined && props.data !== null ? props.data.quantidade :   '',
            taxa_acrescimo:       props.data !== undefined && props.data !== null ? props.data.taxa_acrescimo :   '',
            ativo:                props.data !== undefined && props.data !== null ? !!parseInt(props.data.ativo) : true,
            disponivel:           props.data !== undefined && props.data !== null ? !!parseInt(props.data.disponivel) : true,
            arquivo:              props.data !== undefined && props.data !== null && props.data !== '' ? props.data.imagem :  '',
            arquivo_label:        arquivo_label,
        },
        enableReinitialize: true,
        validationSchema: isAdmin() ? validarAdmin : validarEstabelecimento,
        onSubmit: values => {
            let valor = ((values.valor.replaceAll('.', '')).replaceAll(',', '.')).replaceAll('R$ ', '');
            // let taxa_acrescimo = ((values.taxa_acrescimo.replaceAll('.', '')).replaceAll(',', '.')).replaceAll('R$ ', '');
            let data = {
                "estabelecimento_id": values.estabelecimento_id || (isAdmin()) ? values.estabelecimento_id.value : null,
                "tipo_produto_id": values.tipo_produto_id ? values.tipo_produto_id.value : null,
                "nome" : values.nome,
                "valor" : valor,
                "descricao" : values.descricao,
                "quantidade" : values.quantidade,
                "taxa_acrescimo" : 0.00,//taxa_acrescimo,
                "imagem" : values.arquivo,
                "disponivel": values.disponivel,
                "ativo": values.ativo,
            }

            if (props.operation !== undefined && props.operation !== null && props.operation === 'alt') {
                props.updateProduto(data, props.data.uuid);
            } else {
                props.insertProduto(data);
            }
        },
    });

    return ( 
        <Form className="forms-sample col-12" onSubmit={formik.handleSubmit}>
            <Card>
                <CardHeader className="bg-maskats text-center">
                    <h4 className="headerTitle">Cadastro de produtos</h4>
                </CardHeader>
                <CardBody>
                    <div>

                        {
                            isAdmin() ? 
                                <FormGroup>
                                    <Label for="estabelecimento_id">* Estabelecimento</Label>
                                    <Combobox
                                        invalid={formik.touched.estabelecimento_id && formik.errors.estabelecimento_id}
                                        valid={formik.touched.estabelecimento_id && !formik.errors.estabelecimento_id}
                                        id="estabelecimento_id"
                                        name="estabelecimento_id"
                                        placeholder={'Selecione um item'}
                                        defaultValue={formik.values.estabelecimento_id}
                                        value={formik.values.estabelecimento_id}
                                        options={props.listaEstabelecimentos}
                                        isMulti={false}
                                        loadingMessage={"Carregando..."}
                                        noOptionsMessage={"Não existem dados cadastrados."}
                                        onChange={formik.setFieldValue}
                                        onBlur={formik.setFieldTouched}
                                        maxMenuHeight={190}
                                    />
                                    {formik.touched.estabelecimento_id && formik.errors.estabelecimento_id ? (
                                        <div className="divError">{formik.errors.estabelecimento_id}</div>
                                    ) : null}
                                </FormGroup>
                            : ""
                        }

                        <FormGroup>
                            <Label for="tipo_produto_id">* Tipo do produto</Label>
                            <Combobox
                                invalid={formik.touched.tipo_produto_id && formik.errors.tipo_produto_id}
                                valid={formik.touched.tipo_produto_id && !formik.errors.tipo_produto_id}
                                id="tipo_produto_id"
                                name="tipo_produto_id"
                                placeholder={'Selecione um item'}
                                defaultValue={formik.values.tipo_produto_id}
                                value={formik.values.tipo_produto_id}
                                options={props.listaTiposProduto}
                                isMulti={false}
                                loadingMessage={"Carregando..."}
                                noOptionsMessage={"Não existem dados cadastrados."}
                                onChange={formik.setFieldValue}
                                onBlur={formik.setFieldTouched}
                                maxMenuHeight={190}
                            />
                            {formik.touched.tipo_produto_id && formik.errors.tipo_produto_id ? (
                                <div className="divError">{formik.errors.tipo_produto_id}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="nome">* Nome</Label>
                            <Input 
                                className="form-control form-control-sm"
                                id="nome" 
                                name="nome" 
                                type="text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.nome}
                                minLength={2}
                                maxLength={90}
                            />
                            {formik.touched.nome && formik.errors.nome ? (
                                <div className="divError">{formik.errors.nome}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="valor">* Valor</Label>
                            <MaskedInput
                                mask={numberMask}
                                guide={false}
                                className="form-control form-control-sm" 
                                id="valor" 
                                name="valor" 
                                type="text" 
                                inputMode="decimal"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.valor}
                            />
                            {formik.touched.valor && formik.errors.valor ? (
                                <div className="divError">{formik.errors.valor}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="descricao">Descrição</Label>
                            <Input 
                                className="form-control form-control-sm" 
                                id="descricao" 
                                name="descricao" 
                                type="text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.descricao}
                                maxLength={500}
                            />
                            {formik.touched.descricao && formik.errors.descricao ? (
                                <div className="divError">{formik.errors.descricao}</div>
                            ) : null}
                        </FormGroup>
                        
                        <FormGroup>
                            <Label for="quantidade">Quantidade</Label>
                            <MaskedInput
                                className="form-control form-control-sm" 
                                id="quantidade" 
                                name="quantidade" 
                                type="number" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.quantidade}
                            />
                            {formik.touched.quantidade && formik.errors.quantidade ? (
                                <div className="divError">{formik.errors.quantidade}</div>
                            ) : null}
                        </FormGroup>
                        
                        {/* <FormGroup>
                            <Label for="taxa_acrescimo">Taxa de acréscimo</Label>
                            <MaskedInput
                                mask={numberMask}
                                guide={false}
                                className="form-control form-control-sm" 
                                id="taxa_acrescimo" 
                                name="taxa_acrescimo" 
                                type="text" 
                                inputMode="decimal"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.taxa_acrescimo}
                            />
                            {formik.touched.taxa_acrescimo && formik.errors.taxa_acrescimo ? (
                                <div className="divError">{formik.errors.taxa_acrescimo}</div>
                            ) : null}
                        </FormGroup> */}

                        <FormGroup>
                            <Row>
                                <InputFile formik={formik} title="Imagem"/>
                            </Row>
                        </FormGroup>

                        <FormGroup>
                            <Label for="disponivel">Disponível</Label>
                            <br/>
                            <Switch
                                id="disponivel"
                                name="disponivel"
                                onColor="#28a745"
                                offColor="#dc3545"
                                checked={formik.values.disponivel}
                                onChange={()=>formik.setFieldValue('disponivel', !formik.values.disponivel)}
                                className="mr-2 mb-2"
                            />
                        </FormGroup>

                        <FormGroup className="mb-0">
                            <Label for="ativo">Ativo</Label>
                            <br />
                            <Switch
                                id="ativo"
                                name="ativo"
                                onColor="#28a745"
                                offColor="#dc3545"
                                checked={formik.values.ativo}
                                onChange={()=>formik.setFieldValue('ativo', !formik.values.ativo)}
                            />
                        </FormGroup>
                    </div>
                </CardBody>
                <CardFooter className="text-align-end bg-white">
                    <Link replace to="/produto">
                        <Button className="mr-2 text-white btn btn-sm btn-secondary btn-fw bd-rd-8" type="button">
                            <i className="fa fa-arrow-left btn-icon-append btn-fs-def"></i>
                            <span className="label-button btn-fs-def">Cancelar</span>
                        </Button>
                    </Link>

                    <Button className="btn btn-sm btn-success btn-fw bd-rd-8" type="submit">
                        <i className="fa fa-check btn-icon-append btn-fs-def"></i>
                        <span className="label-button btn-fs-def">Salvar</span>
                    </Button>
                </CardFooter>
            </Card>
        </Form>
    );
}

class ProdutoFormulario extends Component {
    constructor(props){
        super(props);

        this.state = {
            listaEstabelecimentos: [],
            listaTiposProduto: [],
            listaCategoriasProduto: [],
        };
        
        this.loadingShow   = this.loadingShow.bind(this);
        this.updateProduto = this.updateProduto.bind(this);
        this.insertProduto = this.insertProduto.bind(this);
    }

    async componentDidMount(){
        this.loadingShow(true);

        let [listaEstabelecimentos, listaCategoriasProduto, listaTiposProduto ] = await Promise.all([
            getData(`/estabelecimento`, this.props),
            getData(`/categoria-produto`, this.props),
            getData(`/tipo-produto`, this.props)
        ]);

        if(listaEstabelecimentos !== null){
            listaEstabelecimentos = listaEstabelecimentos.map(function (value) {
                return { value: value.id, label: value.nome, ativo: value.ativo };
            });
        }

        if(listaTiposProduto !== null){
            listaTiposProduto = listaTiposProduto.map(function (value) {
                let categoria_produto = listaCategoriasProduto.filter(function (elem, i, object) {
                    return elem.id === value.categoria_produto_id;
                });
                return { value: value.id, label: `(${categoria_produto[0].nome}) ${value.nome}`, ativo: value.ativo };
            });
        }

        this.setState({ listaEstabelecimentos, listaTiposProduto });

        this.loadingShow(false);
    }

    loadingShow(value) {
        let { setLoaderShow } = this.props;
        setLoaderShow(value);
    }

    async updateProduto(data, uuid){
        this.loadingShow(true);
        queryClient.removeQueries('produtos');
        await putData(`/produto/${uuid}`, this.props, data, '../produto');
        this.loadingShow(false);
    }

    async insertProduto(data){
        this.loadingShow(true);
        queryClient.removeQueries('produtos');
        await postData(`/produto`, this.props, data, '../produto');
        this.loadingShow(false);
    }

    render(){
        const { data, operation } = this.props.location;
        const { setResponseModal, enableResponseModal } = this.props;
        return (
            <Fragment>
                <div className="container-scroller">
                    <Navbar/>
                    <div className="container-fluid page-body-wrapper">
                        <Sidebar/>
                        <div className="main-panel">
                            <div className="content-wrapper">
                                <div className="row">
                                    <div className="col-md-12 grid-margin stretch-card">
                                        <Formulario
                                            data={data}
                                            operation={operation}
                                            updateProduto={this.updateProduto}
                                            insertProduto={this.insertProduto}
                                            listaEstabelecimentos={this.state.listaEstabelecimentos}
                                            listaTiposProduto={this.state.listaTiposProduto}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalResponse 
                    history={this.props.history} 
                    setResponseModal={setResponseModal} 
                    enableResponseModal={enableResponseModal}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        enableLoaderShow: state.enableLoaderShow,
        enableResponseModal: state.enableResponseModal,
    }
};

const mapDispatchToProps = dispatch => ({
    setLoaderShow: enable => dispatch(setLoaderShow(enable)),
    setResponseModal: enable => dispatch(setResponseModal(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProdutoFormulario);